export default "__VITE_ASSET__DmaaGO0m__"